const ABILITY_BOUNDARY = Symbol('engine.abilityChoiceBoundary');
export function createAbilityChoiceBoundary() {
    const controller = { fizzled: false };
    return {
        mark(request) {
            const marked = { ...request };
            Object.defineProperty(marked, ABILITY_BOUNDARY, {
                value: controller,
                enumerable: false,
                configurable: false,
                writable: false,
            });
            return marked;
        },
        consumeFizzle() {
            const fizzled = controller.fizzled;
            controller.fizzled = false;
            return fizzled;
        },
    };
}
/** Internal resolution seam; intentionally not re-exported from package root. */
export function markAbilityBoundaryFizzled(request) {
    const controller = request[ABILITY_BOUNDARY];
    if (controller === undefined)
        return false;
    controller.fizzled = true;
    return true;
}
//# sourceMappingURL=fizzleBoundary.js.map